export default __webpack_public_path__ + "static/media/autoupdate-negative.27ea8fbb.svg";